<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you been told you have “borderline” high blood pressure or high blood pressure?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.toldBloodPressureType">
      <b-form-radio v-model="survey.bloodPressure.toldBloodPressureType" name="no" 
                    :value=highBloodPressureType.No>No</b-form-radio>
      <b-form-radio v-model="survey.bloodPressure.toldBloodPressureType" name="borderlineHigh" 
                    :value=highBloodPressureType.BorderlineHigh>Borderline High</b-form-radio>
      <b-form-radio v-model="survey.bloodPressure.toldBloodPressureType" name="high" 
                    :value=highBloodPressureType.High>High</b-form-radio>
    </v-form-group>
    <div v-if="isPressureHighOrBorderlineHigh" class="page-buttons">
      <v-form-group :validator="$v.toldHighMonth" label="Month of the year">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.bloodPressure.toldHighMonth"
                      placeholder="1" />
      </v-form-group>
      <v-form-group :validator="$v.toldHighYear" label="Year">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.bloodPressure.toldHighYear"
                      placeholder="1950" />
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, numeric, between, requiredIf } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import highBloodPressureType from 'enums/high-blood-pressure-type';

  export default {
    mixins: [formMixin],

    data() {
      return {
        highBloodPressureType: highBloodPressureType
      }
    },

    validations: {
      toldBloodPressureType: {
        required
      },
      toldHighMonth: {
        required: requiredIf(function () { return this.isPressureHighOrBorderlineHigh; }),
        numeric,
        between: between(1, 12)
      },
      toldHighYear: {
        required: requiredIf(function () { return this.isPressureHighOrBorderlineHigh; }),
        numeric,
        between: between(1950, new Date().getFullYear())
      }
    },

    computed: {
      ...mapState(["survey"]),

      toldBloodPressureType() { return this.survey.bloodPressure.toldBloodPressureType },
      toldHighMonth() { return this.survey.bloodPressure.toldHighMonth },
      toldHighYear() { return this.survey.bloodPressure.toldHighYear },

      isPressureHighOrBorderlineHigh() {
        return this.toldBloodPressureType === highBloodPressureType.High || this.toldBloodPressureType === highBloodPressureType.BorderlineHigh;
      }
    }
  };
</script>